import { motion } from "framer-motion";
import { useI18n } from "../i18n";

export default function CaraKerja() {
    const { t } = useI18n();
    const STEPS = [
        { no: "01", title: t.h1t, desc: t.h1d, testId: "step-1" },
        { no: "02", title: t.h2t, desc: t.h2d, testId: "step-2" },
        { no: "03", title: t.h3t, desc: t.h3d, testId: "step-3" },
    ];
    return (
        <section id="cara-kerja" className="relative scroll-mt-24 py-24 sm:py-32" data-testid="section-cara-kerja">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.7 }}
                    className="mb-14"
                >
                    <p className="mb-3 font-mono text-[11px] font-bold uppercase tracking-[0.22em] text-brand-coral">
                        {t.h0}
                    </p>
                    <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-5xl">
                        {t.ha} <span className="text-gradient">{t.hb}</span>
                    </h2>
                </motion.div>

                <div className="relative grid gap-6 md:grid-cols-3">
                    <div className="absolute left-0 right-0 top-1/2 hidden border-t border-dashed border-white/15 md:block" />
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.no}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{ duration: 0.6, delay: i * 0.12 }}
                            className="group relative rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-xl transition-colors duration-300 hover:border-white/25"
                            data-testid={s.testId}
                        >
                            <span className="font-mono text-4xl font-bold text-gradient">{s.no}</span>
                            <h3 className="mt-5 font-display text-xl font-bold">{s.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
